import { SideNav, SideNavItem } from '@leafygreen-ui/side-nav';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { css } from "@leafygreen-ui/emotion";
import { palette } from "@leafygreen-ui/palette";
import { useApi } from "../providers/Api";

const divider = css`
  border: 0;
  border-top: 1px solid ${palette.gray.light2};
  margin: 8px 0;
`;

export default function Navigation ({ className }) {
  const location = useLocation();
  const { profile } = useApi();

  return (
    <SideNav aria-label="Navigation Bar" className={className}>
      <SideNavItem aria-label="Home" as={Link} active={location.pathname === "/"} to="/">Home</SideNavItem>
      <SideNavItem aria-label="Short URLs" as={Link} active={location.pathname === "/app/routes"} to="/app/routes">Short URLs</SideNavItem>
      <SideNavItem aria-label="Landing Pages" as={Link} active={location.pathname === "/app/landings"} to="/app/landings">Landing Pages</SideNavItem>
      <li role="separator" className={divider} />
      <SideNavItem aria-label="Passkey Generator" as={Link} active={location.pathname === "/app/passkeygenerator"} to="/app/passkeygenerator">Passkey Generator</SideNavItem>
      <SideNavItem aria-label="Instruqt Invites" as={Link} active={location.pathname === "/app/instruqtinvites"} to="/app/instruqtinvites">Instruqt Invites</SideNavItem>
      <li role="separator" className={divider} />
      <SideNavItem aria-label="UTM Link Builder" as={Link} active={location.pathname === "/app/utmbuilder"} to="/app/utmbuilder">UTM Link Builder</SideNavItem>
      <SideNavItem aria-label="UTM Link Builder MOps" as={Link} active={location.pathname === "/app/utmbuildermops"} to="/app/utmbuildermops">UTM Link Builder MOps</SideNavItem>
      <SideNavItem aria-label="Markdown Link to UTM" as={Link} active={location.pathname === "/app/utmbuilderfrommarkdown"} to="/app/utmbuilderfrommarkdown">Markdown Link to UTM</SideNavItem>
      <SideNavItem aria-label="Dashboard" as={Link} active={location.pathname === "/app/stats"} to="/app/stats">Dashboard</SideNavItem>
      <SideNavItem aria-label="My Profile" as={Link} active={location.pathname === "/app/profile"} to="/app/profile">My Profile</SideNavItem>
      <li role="separator" className={divider} />
      {profile?.isAdmin && (
        <SideNavItem aria-label="Admin Settings" as={Link} active={location.pathname === "/app/adminsettings"} to="/app/adminsettings">Admin Settings</SideNavItem>
      )}
      <SideNavItem aria-label="Logout" as={Link} active={location.pathname === "/logout"} to="/logout">Logout</SideNavItem>
    </SideNav>
  );
}